import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  constructor() { }

  // image resizing functions

  async resizeImage(dataURL: string, maxHeight: number, maxWidth: number) {
    const image = await this.createImageFromDataUrl(dataURL);
    let bgColor = "#ffffff";
    const quality = 0.8;
    const type = this.getImageTypeFromDataUrl(dataURL);

    const canvas = document.createElement("canvas");

    let height = image.height;
    let width = image.width;

    var dim = this.calculateAspectRatio(width, height, maxWidth, maxHeight);

    canvas.width = dim.width;
    canvas.height = dim.height;

    //draw image on canvas
    const ctx = canvas.getContext("2d");

    if (bgColor) {
      ctx.fillStyle = bgColor;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }

    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    // get the data from canvas as 70% jpg (or specified type).
    console.log('resized image to: ',dim);
    return canvas.toDataURL(type, quality);    
  }
  createImageFromDataUrl(dataURL: string) {
    return new Promise<HTMLImageElement>((res, rej) => {
      const image = new Image();
      image.onload = () => res(image);
      image.onerror = rej;
      image.src = dataURL;
    });
  }
  getImageTypeFromDataUrl(dataURL: string): string {
    const typeRE = /^data:([^,;]+)/;
    let matches = dataURL.match(typeRE);
    return (matches && matches[1]) || undefined;
  }
  calculateAspectRatio(srcWidth, srcHeight, maxWidth, maxHeight) {
    var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return { width: srcWidth * ratio, height: srcHeight * ratio };
  }

  
  dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }  
}
